import * as Switch from "@radix-ui/react-switch";

import { cn } from "../lib/cn";

export interface ToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label?: string;
  className?: string;
}

export function Toggle({
  checked,
  onCheckedChange,
  label,
  className,
}: ToggleProps) {
  return (
    <label
      className={cn("inline-flex cursor-pointer items-center gap-2", className)}
    >
      <Switch.Root
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={cn(
          "relative h-5 w-9 rounded-full transition-colors duration-200",
          checked ? "bg-gold-dim" : "bg-[rgba(255,255,255,0.1)]",
        )}
      >
        <Switch.Thumb
          className={cn(
            "block h-4 w-4 rounded-full transition-transform duration-200",
            checked
              ? "bg-gold translate-x-[18px]"
              : "bg-text-muted translate-x-[2px]",
          )}
        />
      </Switch.Root>
      {label && (
        <span className="text-text-dim font-mono text-[10px] uppercase tracking-[0.10em]">
          {label}
        </span>
      )}
    </label>
  );
}
